module.exports = __webpack_public_path__ + "img/answer.cfdf1add.png";